import { useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';

import { getNamespace } from '../utils/storage';
import MessagesContext from '../contexts/messagesContext';

export const useUserClinics = () => {
    const { messages } = useContext(MessagesContext);
    const workspace = getNamespace();
    const userAccess = useSelector(
        (state) => state.user?.userInfo?.namespaces?.find((item) => item.id === workspace)?.access
    );
    const [options, setOptions] = useState([]);

    useEffect(() => {
        const allOptions = { id: '0', name: messages.allClinics };
        if (userAccess?.clinics) {
            const clinics = userAccess.clinics.map((item) => ({ id: item.id, name: item.name }));
            if (clinics?.length)
                setOptions(userAccess?.is_assignee ? [allOptions, ...clinics] : clinics);
        }
    }, [userAccess]);
    return options;
};
